let API_HOSTNAME
if (process.env.NODE_ENV === 'production') {
  API_HOSTNAME = 'https://apis.midmi.vip/api'
} else {
  // API_HOSTNAME = 'http://192.168.0.178:8000/api'
  API_HOSTNAME = 'http://192.168.31.32:8000/api'
}
export const SIGNUP_URL = `${API_HOSTNAME}/auth/signup`
export const SIGNIN_BYUSERNAME_URL = `${API_HOSTNAME}/auth/signin_by_username`
export const SIGNIN_BYPHONENUMBER_URL = `${API_HOSTNAME}/auth/signin_by_phonenumber`
export const VERIFICATE_URL = `${API_HOSTNAME}/auth/verificate`

export const BASE_USER_URL = `${API_HOSTNAME}/users`
export const BASE_POST_URL = `${API_HOSTNAME}/1/article/posts/`
export const BASE_POST_ID_URL = `${API_HOSTNAME}/1/article/?id=`
export const BASE_TOPIC_URL = `${API_HOSTNAME}/topics`
export const BASE_CATEGORY_URL = `${API_HOSTNAME}/1/category/?id=`
export const BASE_CATEGORIES_URL = `${API_HOSTNAME}/1/categories`
export const BASE_LIKE_URL = `${API_HOSTNAME}/likes`
export const BASE_COMMENT_URL = `${API_HOSTNAME}/comments`
export const BASE_HOME_URL = `${API_HOSTNAME}/1/home/list/`

export const BASE_GALLERY_URL = `${API_HOSTNAME}/1/resource/posts/`
export const BASE_GALLERY_ID_URL = `${API_HOSTNAME}/1/resource/?id=`

export const BASE_ALBUM_URL = `${API_HOSTNAME}/1/chapter/posts/`
export const BASE_ALBUM_ID_URL = `${API_HOSTNAME}/1/chapter/?id=`

export const ADMIN_URL = 'https://manage.midmi.vip/admin'



// WEBPACK FOOTER //
// ./src/constants/API.js